import { render } from "./RankingItem.vue?vue&type=template&id=4ae7d0cf&scoped=true"
import script from "./RankingItem.vue?vue&type=script&lang=js"
export * from "./RankingItem.vue?vue&type=script&lang=js"

import "./RankingItem.vue?vue&type=style&index=0&id=4ae7d0cf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4ae7d0cf"

export default script